import { z } from 'zod';
/**
 * Lifecycle status of a recorded decision — the closed string set the
 * `/decisions` register filters and color-codes against. Lives in
 * `packages/shared` so the future `decisions` collection writer (server)
 * and the register UI (web) reference the same enum instead of
 * re-typing literal strings.
 *
 * States:
 *   ACTIVE      — Decision currently in force. Color: sage.
 *   REVISIT     — Decision in force but explicitly flagged for re-evaluation
 *                 by a scheduled date (e.g. "re-evaluate at Q3 board").
 *                 Color: accent.
 *   REVERSED    — Decision was rolled back. The card stays in the log for
 *                 historical context; the rationale entry typically explains
 *                 what didn't survive contact with reality. Color: rose.
 *   SUPERSEDED  — A newer decision replaces this one (still discoverable
 *                 in the log, but no longer the operative call). Color: steel.
 */
export const DecisionStatus = z.enum(['ACTIVE', 'REVISIT', 'REVERSED', 'SUPERSEDED']);
